import { SVGProps, Ref, forwardRef } from 'react';

export const BracketsOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6 1.9H3.366v3.433A3.36 3.36 0 0 1 2.054 8a3.36 3.36 0 0 1 1.312 2.667v3.434H6V15.5H1.967v-4.833C1.967 9.581 1.087 8.7 0 8.7V7.3c1.086 0 1.967-.88 1.967-1.967V.5H6z"
                fill="currentColor"
            />
            <path
                d="M14.033 5.333c0 1.086.88 1.967 1.967 1.967v1.4c-1.086 0-1.967.88-1.967 1.967V15.5H10v-1.4h2.634v-3.433c0-1.086.514-2.051 1.311-2.667a3.36 3.36 0 0 1-1.311-2.667V1.899H10V.5h4.033z"
                fill="currentColor"
            />
            <path d="m10.626 4.313-4 8-1.252-.626 4-8z" fill="currentColor" />
        </g>
    </svg>
));
BracketsOutlinedSize16Glyph.displayName = 'BracketsOutlinedSize16Glyph';
